export default {
  logo(state) {
    return state.logoUrl
  },
}
